var _ellipse, _ellipse2, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBubblePinBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 75,
    viewBox: "0 0 71 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 35.0795,
    cy: 61.0734,
    rx: 23.0736,
    ry: 13.4721,
    fill: "#234F68"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 35.08,
    cy: 61.0733,
    rx: 10.6494,
    ry: 6.28697,
    fill: "#234F68",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2332 49.7018H1V24.3867H69.1605V49.7018H45.5428H45.1044L44.8073 50.0242L35.6737 59.9383L25.9478 50.0023L25.6536 49.7018H25.2332Z",
    fill: "#2898FF",
    stroke: "#F8F8F9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.5044 55.5439H23.3867",
    stroke: "#F8F8F9",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblePinBase);
export default __webpack_public_path__ + "static/media/bubblePinBase.feaaab7c8ad67fd486e09cc676b3f792.svg";
export { ForwardRef as ReactComponent };